export const normalizeFetchLayersGroupReportResponse = response =>
    response.map(layerGroup => ({
        layer: {
            id: layerGroup.layer_id,
            name: layerGroup.layer_name,
        },
        group: {
            id: layerGroup.cluster_id,
            name: layerGroup.cluster_name,
            feedback: layerGroup.feedback,
            grade: layerGroup.grade === null ? null : Number(layerGroup.grade),
            numberOfSubmissions: layerGroup.no_of_files,
        },
    }))
